import { render } from "./CurrentQueue.vue?vue&type=template&id=54a68e37&scoped=true&ts=true"
import script from "./CurrentQueue.vue?vue&type=script&lang=ts"
export * from "./CurrentQueue.vue?vue&type=script&lang=ts"

import "./CurrentQueue.vue?vue&type=style&index=0&id=54a68e37&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a68e37"]])

export default __exports__